import type { Editor } from "@tiptap/core";
import { omit } from "lodash";

interface CTAAttrs {
  color: string;
  label: string;
  may_lead_to_purchase?: boolean;
  text_color: string;
  url: string;
}

interface InsertCTAParams {
  attrs: CTAAttrs;
  editor: Editor;
  isEdit: boolean;
  isWithinEmailEditor?: boolean;
  range: { from: number; to: number };
}

export const insertCTA = ({
  editor,
  range,
  attrs,
  isEdit,
  isWithinEmailEditor,
}: InsertCTAParams) => {
  editor
    .chain()
    .focus()
    .insertContentAt(
      range,
      [
        {
          type: "cta",
          attrs: omit(
            attrs,
            isWithinEmailEditor ? "may_lead_to_purchase" : "text_color",
          ),
        },
        !isEdit && { type: "hardBreak" },
      ].filter(Boolean),
    )
    .run();
};
